import styled from '@emotion/styled'
import Label from '../inputs/Label'
import Text from '../inputs/Text'
import { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import tw from 'twin.macro'
import { useSessionStorageState } from '../../utils/useSessionStorageState'
import { lookupStorageKey } from '../../apollo/cache'
import { UserQuery } from '../../apollo/queries'
import { getDefaultLandingPage } from '../../utils/getDefaultLandingPage'
import { redirectAfterLogin } from '../../utils/redirectAfterLogin'
import { Loading } from '../Loading'
import Button from '../Button'
import ShadowBox from '../layout/ShadowBox'
import Subtitle from '../headings/Subtitle'
import H2 from '../headings/H2'
import Image from 'next/image'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

toastr.options = {
  positionClass : 'toast-top-right',
  hideDuration: 300,
  timeOut: 3000
}

const Div = styled.div(tw`relative mb-6`)

const initialState = {
  authenticated: false,
  orderNumber: '',
  user: '',
  order: '',
  orders: '',
  rows: [],
  search: '',
  criteria: 'source_id'
}

const Lookup = () => {
  useEffect(() => {
    setUser({
      email: '',
      password: ''
    })

    if(state.authenticated) {
      window.location.assign(getDefaultLandingPage(state.user))
    }
  }, [])

  useEffect(() => {
    const html = document.documentElement
    const body = document.body
    const previousHtmlOverflow = html.style.overflow
    const previousBodyOverflow = body.style.overflow

    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'

    return () => {
      html.style.overflow = previousHtmlOverflow
      body.style.overflow = previousBodyOverflow
    }
  }, [])

  const [user, setUser] = useState({
    email: '',
    password: ''
  })

  const [state, setState] = useSessionStorageState(
    lookupStorageKey,
    initialState,
  )
  
  const [error, setError] = useState('')
  const [userlogin, {loading}] = useLazyQuery(UserQuery, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      if(data.getUser.id != null) {
        redirectAfterLogin(data.getUser, state)
      } else {
        toastr.error('Email or Password is incorrect! Try again')
      }
    },
    onError(error) {
      console.log(error)
      setError(
        `No User were found matching your email and password. If you believe this is a mistake, please refresh your browser and try again.`,        
      )
    },
  })

  function submitHandler(e) {
    e.preventDefault()
    setError('')   

    if (!user.email || !validateEmail(user.email)) {
      setError('Email address is required')
      return
    }

    if (!user.password) {
      setError('User Password is required')
      return
    }

    userlogin({
      variables: {email: user.email, password: user.password},
    })
  }

  function handleChange(e) {
    setUser({
      ...user,
      [e.currentTarget.name]: e.currentTarget.value,
    })
    setError('')
  }

  return (
    !state.authenticated && (
      <main tw="fixed inset-0 flex items-center justify-center overflow-hidden p-4 background[linear-gradient(to bottom, #AEF5EE, #fff)]">
        <ShadowBox
          tw="mt-0 max-w-lg w-full mx-auto width[calc(100vw - 2rem)]"
          style={{minWidth: 'clamp(300px, 440px, 40vw)'}}
        >
          <header tw="text-center">
            <Image
              alt="Dangle It Logo"
              width="160"
              height="53"
              tw="h-8 w-auto mx-auto text-center"
              src="/logo.png"
              quality={100}
            />
            <H2>Universal Admin Portal</H2>
            <Subtitle>Let&apos;s find an order</Subtitle>
          </header>
          <form onSubmit={submitHandler} tw="mt-4">
            <Div>
              <Label id="orderNumber" text="Email:" />
              <Text
                type="text"
                name="email"
                onChange={handleChange}
                value={user.email}
                autoComplete="off"
              />
            </Div>
            <Div>
              <Label id="email" text="Password:" />
              <Text
                type="password"
                name="password"
                onChange={handleChange}
                value={user.password}
                autoComplete="given-name"
              />
            </Div>

            <div tw="text-center">
              <Button tw="bg-brand text-white rounded py-2 px-16 mx-auto uppercase flex items-center transition-all">
                Go
                {loading && <Loading tw="ml-2" />}
              </Button>
              <a
                tw="underline mt-4 text-xs inline-block opacity-80"
                href="https://dangleit.com/pages/contact-us-1"
                target="_blank"
                rel="noreferrer"
              >
                Having trouble logging in?
              </a>
            </div>
            {error && (
              <p tw="mt-2 text-sm text-center text-red-600">{error}</p>
            )}
          </form>
        </ShadowBox>
      </main>
    )
  )
}

Lookup.displayName = 'GraphicServicePortal'
export default Lookup

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}